// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"96338e53","453":"0e59a786"}[chunkId] + ".chunk.js";
};